import { FC, memo } from 'react'

interface SectionHeaderActionsProps {
    children: React.ReactNode
}

const SectionHeaderActions: FC<SectionHeaderActionsProps> = ({ children }) => {
    return (
        <div className="flex items-center gap-x-4">
            {children}
        </div>
    )
}

export default memo(SectionHeaderActions)

